// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3e2gj","title":"FrontImage_title__1eQG6"};